import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { supabase } from '@/integrations/supabase/client';
import { useNavigate } from 'react-router-dom';
import { Shield, CheckCircle, AlertCircle } from 'lucide-react';

const CreateAdmin = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const createAdminAccount = async () => {
    setLoading(true);
    setError('');

    try {
      // Use the edge function to create admin account
      const { data, error } = await supabase.functions.invoke('force_create_admin_2025_12_03_10_30');

      if (error) {
        throw error;
      }

      if (data.success) {
        setSuccess(true);
      } else {
        throw new Error(data.error || 'Failed to create admin account');
      }
    } catch (error: any) {
      console.error('Admin creation error:', error);
      setError(error.message || 'Failed to create admin account');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-background to-secondary flex items-center justify-center p-4">
        <Card className="w-full max-w-md">
          <CardHeader className="text-center">
            <CheckCircle className="h-12 w-12 text-green-600 mx-auto mb-4" />
            <CardTitle>Admin Account Ready!</CardTitle>
            <CardDescription>
              The administrator account has been created successfully.
            </CardDescription>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            <div className="p-4 bg-green-50 rounded-lg">
              <p className="text-sm font-medium">Admin Login Credentials:</p>
              <p className="text-sm text-muted-foreground">Email: vladimir.bunic@convergedsecurity.es</p>
              <p className="text-sm text-muted-foreground">Password: Vbunic@1720</p>
            </div>
            <div className="p-4 bg-blue-50 rounded-lg">
              <p className="text-xs text-muted-foreground">
                If you received a verification email, please click the link to confirm your email address.
              </p>
            </div>
            <div className="flex flex-col gap-2">
              <Button onClick={() => navigate('/admin-login')}>
                Go to Admin Login
              </Button>
              <Button variant="outline" onClick={() => navigate('/')}>
                Back to Home
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-secondary flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <Shield className="h-12 w-12 text-primary mx-auto mb-4" />
          <CardTitle>Create Administrator Account</CardTitle>
          <CardDescription>
            Set up the administrator account for CSI Membership Portal
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {error && (
            <Alert variant="destructive">
              <AlertCircle className="h-4 w-4" />
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}

          <div className="p-4 bg-blue-50 rounded-lg">
            <h4 className="font-medium mb-2">Administrator Details:</h4>
            <div className="space-y-1 text-sm text-muted-foreground">
              <p><strong>Name:</strong> Vladimir Bunic</p>
              <p><strong>Email:</strong> vladimir.bunic@convergedsecurity.es</p>
              <p><strong>Password:</strong> Vbunic@1720</p>
              <p><strong>Organization:</strong> Converged Security Institute</p>
              <p><strong>Role:</strong> Administrator</p>
            </div>
          </div>

          <Button 
            onClick={createAdminAccount}
            className="w-full" 
            disabled={loading}
          >
            {loading ? 'Creating Administrator Account...' : 'Create Administrator Account'}
          </Button>

          <div className="text-center">
            <Button variant="link" onClick={() => navigate('/')}>
              Back to Home
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CreateAdmin;